import { usePage } from "@/components/page/PageContext";
import { DisruptionSection } from "@/components/disruption/DisruptionSection";
import { SummaryDisplay as Summary } from "@/pages/overview/Summary";
import { useReportContext } from "@/stores/ReportContext";
import { useSessionData } from "@/stores/SessionDataContext";
import React, { useEffect } from "react";

const HomePage: React.FC = () => {
  const { code_iata } = useSessionData();
  const { reportId, report, formattedDate } = useReportContext();
  const { setTitles } = usePage();
  useEffect(() => {
    setTitles(["Airport Overview"]);
  }, []);

  if (!report) {
    return (
      <div>
        Initial Report not generated yet. Please contact support if you see this
        message for longer than 1 hour.
      </div>
    );
  }

  return (
    <div className={"mx-2 sm:mx-4 mt-4 sm:mt-6"}>
      <div className={"text-center text-2xl sm:text-3xl lg:text-5xl text-indigo-400 mt-4 sm:mt-6 px-2"}>
        {code_iata} Overview for {formattedDate}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 mt-6 sm:mt-8 md:mx-4 gap-2">
        {report.summary_flights && (
          <div className="w-full p-2 sm:p-4">
            <Summary
              summary={report.summary_flights}
              totalCaption={"Total Flights"}
              disableConcourse={false}
            />
          </div>
        )}
        {report.summary_pax && (
          <div className="w-full p-2 sm:p-4">
            <Summary
              summary={report.summary_pax}
              totalCaption={"Total Passengers"}
              disableConcourse={false}
            />
          </div>
        )}
        {report.summary_bags && (
          <div className="w-full p-2 sm:p-4">
            <Summary
              summary={report.summary_bags}
              totalCaption={"Total Bags"}
              disableConcourse={true}
            />
          </div>
        )}
        {report.summary_concerns && (
          <div className="w-full p-2 sm:p-4">
            <Summary
              terminalLinkPattern="/data/terminal/{terminal}/pain-points"
              concourseLinkPattern="/data/concourse/{concourse}/pain-points"
              summary={report.summary_concerns}
              totalCaption={"Total Pain Points"}
              disableConcourse={false}
            />
          </div>
        )}
      </div>
      <DisruptionSection
        summary={report.summary_canceled}
        reportId={reportId}
        reportType={report.type}
        scopeLabel={`Airport-wide · ${code_iata}`}
      />
      <div className={"prose prose-invert sm:mx-8 mx-4 mt-6"}>
        <h3>Legend:</h3>
        <ul>
          <li>
            <span className={"text-green-600"}>Green</span> - Good Condition;
            Value is below 25% of Concern Threshold
          </li>
          <li>
            <span className={"text-amber-600"}>Orange</span> - Watch Condition;
            Value is at-least 25% of Concern Threshold
          </li>
          <li>
            <span className={"text-red-600"}>Red</span> - Warning Condition;
            Value has reached or exceeded Concern Threshold
          </li>
        </ul>
      </div>
    </div>
  );
};

export default HomePage;
